import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "upload-limit-exceptions-dialog__content" }
const _hoisted_2 = { class: "upload-limit-exceptions-dialog__tip" }
const _hoisted_3 = {
  key: 1,
  class: "upload-limit-exceptions-dialog__errors"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isUploadModalOpen,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isUploadModalOpen) = $event)),
    title: "Upload limit exceptions",
    width: "500px",
    class: "upload-limit-exceptions-dialog",
    onClose: _ctx.closeUploadModalAction
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: _ctx.closeUploadModalAction }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Cancel ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_el_button, {
        type: "primary",
        loading: _ctx.isUploadLoading,
        disabled: _ctx.isUploadDisabled,
        onClick: _ctx.uploadLimitExceptionsFile
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Upload ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["loading", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_upload, {
          ref: "uploadRef",
          action: "#",
          "auto-upload": false,
          limit: 1,
          accept: _ctx.ACCEPT_EXCEL_EXTENSIONS,
          "on-change": _ctx.changeUploadedFile,
          "on-remove": _ctx.removeUploadedFile,
          "on-exceed": _ctx.replaceUploadedFile
        }, {
          tip: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, " Only Excel files " + _toDisplayString(_ctx.ACCEPT_EXCEL_EXTENSIONS) + " are allowed ", 1 /* TEXT */)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              disabled: _ctx.isSelectFileDisabled
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" Select file ", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["disabled"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["accept", "on-change", "on-remove", "on-exceed"]),
        (_ctx.isSuccessAlertVisible)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              class: "upload-limit-exceptions-dialog__alert",
              title: _ctx.successAlertTitle,
              type: "success",
              closable: false
            }, null, 8 /* PROPS */, ["title"]))
          : _createCommentVNode("v-if", true),
        (_ctx.isErrorsPresent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadErrors, (errorText, index) => {
                return (_openBlock(), _createBlock(_component_el_alert, {
                  key: index,
                  class: "upload-limit-exceptions-dialog__alert",
                  title: errorText,
                  type: "error",
                  closable: false
                }, null, 8 /* PROPS */, ["title"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onClose"]))
}